<script lang="ts">
	import { PUBLIC_R2_URL } from '$env/static/public';
	import Actirise, { Mode, PageType } from '$lib/components/Actirise.svelte';
	import LdTag from '$lib/components/LdTag.svelte';
	import { translations } from '$lib/i18n/translations';
	import { informationPage } from '$lib/utils/SchemaHelper';
	import type { PageData } from './$types';

	export let data: PageData;

	const property = data.property;
	const t = translations(property.language);
	const colors = property.colors;

	$: canonical = data.canonical;
</script>

<svelte:head>
	<title>{t('contactUs')} - {property.name}</title>
	<link rel="canonical" href={canonical} />
	<meta name="description" content={t('contactUsDescription', { siteName: data.property.name })} />
	<meta name="keywords" content={t('contactUsKeywords')} />

	<meta property="og:url" content={canonical} />
	<meta property="og:type" content="website" />
	<meta property="og:title" content={`${t('contactUs')} - ${property.name}`} />
	<meta
		property="og:description"
		content={t('contactUsDescription', { siteName: data.property.name })}
	/>
</svelte:head>

<Actirise
	mode={Mode.PAGE}
	type={PageType.WHATEVER}
	parameters={{
		custom1: data.cmp.mode
	}}
/>

<LdTag
	schema={informationPage(
		property,
		t('contactUs'),
		t('contactUsDescription', { siteName: data.property.name }),
		canonical
	)}
></LdTag>

<figure>
	<img
		src={PUBLIC_R2_URL + '/office.jpg'}
		alt={t('contactUs_officeAlt')}
		class="w-full h-60 object-cover rounded-lg mb-6"
	/>
</figure>

<h1 class="text-3xl font-extrabold">{t('contactUs')}</h1>
<p class="text-lg mb-6 mt-1">
	{t('contactUsDescription')}
</p>

<div class="flex flex-col lg:flex-row mt-4 gap-6 text-center">
	<div class="basis-1/3">
		<h2 class="text-2xl font-bold">{t('contactUs_office')}</h2>
		<p class="mt-3">
			Attraction Web S.E.C.<br />
			200-5455 Avenue de Gaspé<br />
			Montréal, QC, H2T 3B3<br />
			Canada
		</p>
	</div>
	<div class="basis-1/3">
		<h2 class="text-2xl font-bold">{t('contactUs_email')}</h2>
		<p class="mt-3">
			<a
				class={`${colors.text} hover:${colors.hover} hover:underline`}
				href="mailto:numerique@attraction.ca">numerique@attraction.ca</a
			>
		</p>
	</div>
	<div class="basis-1/3">
		<h2 class="text-2xl font-bold">{t('contactUs_phone')}</h2>
		<p class="mt-3">
			<a class={`${colors.text} hover:${colors.hover} hover:underline`} href="tel:+15148461222"
				>+1.514.846.1222</a
			>
		</p>
	</div>
</div>
